import Toast from '../../../client/toast.js'

export default class Product
{
	static bookmark(product)
	{
		const data = new FormData()

		data.set('__action', 'bookmark')
		data.set('product', product)

		$.ajax({
			url : '/my/',
			type: 'POST',

			processData: false,
			contentType: false,

			data   : data,
			success: (data) =>
			{
				if(!data.success) Toast.warning(data.message)
				else Toast.success(data.message)
			},
		})
	}

	static count(plus, repeat, stock, limit)
	{
		var repeat_id = repeat ? '_repeat' : ''

		var adjust = plus ? 1 : -1
		var count = Number($('#count' + repeat_id).text()) + adjust

		if(count < 1) return

		if(stock && count > stock)
		{
			Toast.warning('在庫の限度数に達しました')
			return
		}

		if(limit && count > limit)
		{
			Toast.warning('注文限度数に達しました')
			return
		}

		$('#count' + repeat_id).text(count)
		$('#count_input' + repeat_id).val(count)
	}
}
